export const DUEL_CONFIRMATION_DESCRIPTION =
  'Are you sure you want to finish the game? The page will refresh';

export const DUEL_CONFIRMATION_TEXT = 'Finish game';

export const DUEL_ABORT_TEXT = 'Continue game';
